import React, { useMemo, useState } from "react";

import { DataGrid, GridToolbarQuickFilter } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import { MDBModal, MDBModalHeader, MDBModalBody, MDBModalFooter, MDBBtn } from "mdbreact";

export default function Basic(props) {
    const [confirmModal, setConfirmModal] = useState(false);
    const [selectedSSID, setSelectedSSID] = useState(null);
    const [selectedUnitID, setSelectedUnitID] = useState(null);

    const toggleConfirmModal = () => {
        setConfirmModal(!confirmModal);
    };

    const handleRemoveClick = (ssid, unitID) => {
        setSelectedSSID(ssid);
        setSelectedUnitID(unitID);
        setConfirmModal(true);
    };

    const confirmRemove = () => {
        if (props.removeUnitSSID && selectedSSID && selectedUnitID) {
            props.removeUnitSSID(selectedSSID, selectedUnitID);
        }
        setConfirmModal(false);
        setSelectedSSID(null);
        setSelectedUnitID(null);
    };

    const rows = useMemo(() => {
        if (!props.keyPoolList) return [];
        return Object.keys(props.keyPoolList).map((key, index) => {
            const keypool = props.keyPoolList[key];
            const scope = keypool["Scope"];
            
            // Unit-level keypools have Scope that matches the pattern with building.floor at the end
            // Global/venue keypools would have "global" or shorter venue-level paths
            const isUnitLevel = scope && scope !== "global" && scope !== "local" && scope.split(".").length > 8;
            
            return {
                id: index,
                ssid: keypool["ssid"],
                scope: scope,
                authenticationMechanism: keypool["AuthenticationMechanism"],
                isUnitLevel: isUnitLevel,
                unitID: isUnitLevel ? scope : null, // For unit-level, the Scope IS the UnitID_internal
            };
        });
    }, [props.keyPoolList]);

    const columns = [
        {
            field: "ssid",
            headerName: "SSID",
            minWidth: 200,
        },
        {
            field: "scope",
            headerName: "Scope",
            minWidth: 1000,
        },
        {
            field: "authenticationMechanism",
            headerName: "Authentication Mechanism",
            minWidth: 200,
        },
        {
            field: "action",
            headerName: "Action",
            width: 100,
            sortable: false,
            filterable: false,
            renderCell: (params) => {
                if (params.row.isUnitLevel && !props.disableRemove) {
                    return (
                        <a
                            href="#!"
                            style={{ color: "red", cursor: "pointer", textDecoration: "underline" }}
                            onClick={(e) => {
                                e.preventDefault();
                                handleRemoveClick(params.row.ssid, params.row.unitID);
                            }}
                        >
                            Remove
                        </a>
                    );
                }
                return "";
            },
        },
    ];

    return (
        <>
            <MDBModal isOpen={confirmModal} toggle={toggleConfirmModal}>
                <MDBModalHeader toggle={toggleConfirmModal}>
                    Confirm SSID Removal
                </MDBModalHeader>
                <MDBModalBody>
                    <p>Are you sure you want to remove the unit-level SSID <strong>{selectedSSID}</strong>?</p>
                    <p className="text-muted">This will remove the SSID from the unit configuration.</p>
                </MDBModalBody>
                <MDBModalFooter>
                    <MDBBtn color="danger" onClick={confirmRemove}>
                        Confirm Removal
                    </MDBBtn>
                    <MDBBtn color="primary" onClick={toggleConfirmModal}>
                        Cancel
                    </MDBBtn>
                </MDBModalFooter>
            </MDBModal>
            <Box sx={{ width: "100%" }} className="keyPools">
            <DataGrid
                rows={rows}
                columns={columns}
                disableRowSelectionOnClick
                hideFooterPagination
                hideFooter
                autoHeight
                disableColumnMenu
                slots={{ toolbar: GridToolbarQuickFilter }}
                slotProps={{
                    toolbar: {
                        showQuickFilter: true,
                        quickFilterProps: { debounceMs: 300 },
                    },
                }}
                localeText={{ noRowsLabel: "No Service Plans Found" }}
                sx={{
                    "& .MuiDataGrid-columnHeaders": {
                        fontWeight: "bold",
                    },
                }}
            />
        </Box>
        </>
    );
}
